<template>
    <div id="web-newsList">
        <div class="wrapper">
            <div class="L-container-fluid  d-none d-md-block">
                <div class="row">
                    <div class="col-12 col-md-12 col-xl-12" v-for="(item,index) in newsList" :key="item.id"
                        @click=linkInfo(item)>
                        <div class="List-item">
                            <div class="List-item-content">
                                <div class="item-left">
                                    <div><img :src="item.headerImageUrl" alt="" class="left-img"></div>
                                    <div class="time">
                                        <div class="top-date">{{item.topDate}}</div>
                                        <div class="year">{{item.year}}</div>
                                    </div>
                                </div>
                                <div class="item-center">
                                    <div class="title">{{item.title}}</div>
                                    <div class="introduction">
                                        {{item.summary}}
                                    </div>
                                </div>
                                <div class="item-right">
                                    <div class="images"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="pag">
                    <b-pagination v-model="currentPage" :total-rows="rows" align="center" :per-page="count"
                        @input="pageChanged" active-bg="#1f539c"></b-pagination>
                </div>
            </div>
            <div class="d-md-none">
                <div class="phone">
                    <!-- 新闻列表页面移动端 -->
                    <div class="phone-item" v-for="(item,index) in newsList" :key="index" @click=linkInfo(item)>
                        <div class="top">
                            <img :src="item.headerImageUrl" alt="" class="img-phone">
                        </div>
                        <div class="title-content">
                            <div class="title nowrap_ellipsis">{{item.title}}</div>
                            <div class="year">{{item.handleDate}}</div>
                        </div>
                    </div>
                    <div class="pag">
                        <b-pagination v-model="currentPage" :total-rows="rows" align="center" :per-page="count"
                            @input="pageChanged" active-bg="#1f539c"></b-pagination>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </div>
</template>
<script>
    import axios from 'axios';
    import dayjs from 'dayjs'
    // 获取设备类型（简单示例，实际上最好使用CSS媒体查询辅助判断）
    function getDeviceType() {
        const width = window.innerWidth || document.documentElement.clientWidth;
        if (width > 768) {
            return 'desktop';
        } else {
            return 'mobile';
        }
    }
    export default {
        name: "NewsList",
        components: {
        },
        data() {
            return {
                deviceType: "desktop",
                imgUrl: require('@/assets/web/img/newsList.png'),
                imgUrlphone: require('@/assets/web/img/newsList-phone.png'),
                currentPage: 1,
                count: 8,
                newsList: [],
                rows: null,
            };
        },
        created() {
            this.deviceType = getDeviceType();
        },
        destroyed() {
        },
        async mounted() {
            this.getNewsList()
        },
        metaInfo() {
            return {
                title: "新闻公告—广州光晨信息科技有限公司",
                meta: [
                    { name: "keywords", content: "光晨科技,广州光晨科技,广州光晨信息科技有限公司" },
                    { name: "description", content: "光晨科技成立于2015年，凭借大数据输出的战略洞察、创造力、行动力等生产实效的核心竞争力，为客户提供全域数字内容营销。" },
                ],
            };
        },
        methods: {
            pre() {

            },
            next() {

            },
            async pageChanged(page) {
                this.currentPage = page;
                this.getNewsList()
            },
            async getNewsList() {
                let data = {
                    page: this.currentPage - 1,
                    count: this.count,
                    publishStatus: 1
                }
                const news = await axios.post('https://www.glotech.com.cn/api/v1/news/page', data, {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                })
                let newsList = news.data.records
                for (const item of newsList) {
                    item['handleDate'] = dayjs(item.publishDate).format('YYYY/MM/DD') // '25/01/2019'
                }
                this.newsList = newsList
                this.rows = news.data.total
                window.scrollTo(0, 0)
            },
            // 跳转详情
            linkInfo(item) {
                // 存取按进去的新闻信息
                localStorage.setItem("currenObjId", JSON.stringify(item.id))
                this.$router.push({
                    name: "NewsInfo",
                    params: { id: item.id },
                }).catch(error => {
                    if (error.name === 'NavigationDuplicated') {
                        console.warn('尝试导航到当前页面，已忽略重复操作');
                    } else {
                        throw error;
                    }
                });
            }

        },
    }
</script>